import { Stack, Typography } from '@mui/material';
import { useContext } from 'react';
import { MTDialog } from '@/components/common/MTDialog';
import {
  COMMON_STRING,
  DICTIONARY,
  RESTORE_CONFIRMATION_STRING,
} from '@/constants/dictionary';
import { ActionDialogProps } from '@/components/ActionsDialog/types';
import { ConfirmButtons } from '@/components/ActionsDialog/ConfirmButtons';
import { ScoringContext } from '@/contexts/scoring/context';
import {
  RestoreFixtureActionMsg,
  SCORING_WORKER_HOST_ACTION,
} from '@/workers/scoring/types';

export const RestoreActionDialog = ({ action, onClose }: ActionDialogProps) => {
  const {
    state: { fixtureId, collectionId },
    useDispatchWithResponse,
  } = useContext(ScoringContext);

  const { dispatch: restoreAction, isLoading } =
    useDispatchWithResponse<RestoreFixtureActionMsg>(
      SCORING_WORKER_HOST_ACTION.RESTORE_FIXTURE_ACTION,
    );

  const onSubmit = async () =>
    await restoreAction(
      { fixtureId, collectionId, fixtureActionId: action.id },
      { successMessage: DICTIONARY.SUCCESS.ACTION_SUCCESSFULLY_RESTORED },
    ).finally(onClose);

  return (
    <MTDialog
      open={true}
      onClose={onClose}
      title={COMMON_STRING.RESTORE_ACTION}
      maxWidth='xs'
      fullWidth
      sx={{ justifyContent: 'left' }}
    >
      <Stack gap={2} width='100%'>
        <Typography>{RESTORE_CONFIRMATION_STRING.ACTION}</Typography>
        <ConfirmButtons
          onSubmit={onSubmit}
          onReject={onClose}
          isLoading={isLoading}
        />
      </Stack>
    </MTDialog>
  );
};
